import { Button, IconArrowInbox, Flex } from '@sequencehq/core-components'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { RevRecHeader } from '../common/RevRecHeader'
import { ExportDeferredRevenueScheduleModal } from './exportDeferredRevenueSchedule.modal'
import { DEFERRED_REVENUE_EXPORT_COPY } from './deferredRevenueExport.constants'
import { useDeferredRevenueFiltersFromUrl } from './useDeferredRevenueFiltersFromUrl'
import type { DeferredRevenueTableGroupBy } from './content/DeferredRevenueDashboardTable'

type Props = {
  asOfDate: Date
  groupBy: DeferredRevenueTableGroupBy
}

export const DeferredRevenueDashboardHeader = ({
  asOfDate,
  groupBy
}: Props) => {
  const { useAsyncDeferredRevenueExport } = useFeatureFlags()

  const { customerIds, productIds, invoiceIds, excludeFullyRecognized } =
    useDeferredRevenueFiltersFromUrl()

  return (
    <RevRecHeader>
      <RevRecHeader.Breadcrumbs route="deferred-revenue" />
      {useAsyncDeferredRevenueExport && (
        <Flex paddingTop="8px">
          <ExportDeferredRevenueScheduleModal
            asOfDate={asOfDate}
            groupBy={groupBy}
            customerIds={customerIds}
            productIds={productIds}
            invoiceIds={invoiceIds}
            excludeFullyRecognized={excludeFullyRecognized}
            trigger={
              <Button
                variant="secondary"
                leadingIcon={<IconArrowInbox />}
                data-testid="defrev.detail.exportCSV"
                aria-label={DEFERRED_REVENUE_EXPORT_COPY.triggerAriaLabel}
              >
                {DEFERRED_REVENUE_EXPORT_COPY.triggerLabel}
              </Button>
            }
          />
        </Flex>
      )}
    </RevRecHeader>
  )
}
